import React, { useCallback, useMemo } from "react";
import { setAtPath } from "./editors/shared/pathUpdate";
import PartsEditor from "./editors/project/PartsEditor";

export default function ProjectEditor({ contentJson, setContentJson }) {
    const updateContentAtPath = useCallback(
        (path, value) => {
            setContentJson((prev) => setAtPath(prev, path, value));
        },
        [setContentJson]
    );

    const rootPath = useMemo(() => [], []);

    if (!contentJson) {
        return <div style={{ padding: 16 }}>No content loaded.</div>;
    }

    return (
        <div className='d-grid gap-8'>
            <PartsEditor
                project={contentJson}
                path={rootPath}
                updateAtPath={updateContentAtPath}
            />
        </div>
    );
}
